import React from "react";
import "./Hero.css";

const Hero = () => {
  return (
    <section id="hero" className="Hero">
      <div className="Hero_Content">
        <div className="Hero_Text">
          <h1>Objects that make your space breathe.</h1>
          <p>Handcrafted-inspired ceramics for calm mornings, quiet evenings, and homes that tell stories in silence.</p>
          <button className="Hero_Button">Shop Now</button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
